/**
 * @fileoverview Public entry point to the pending two-factor challenge.
 * @description Thin wrapper over the two-factor challenge store so route guards and feature code
 * depend on shared/lib/auth instead of importing the store directly.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useTwoFactorChallengeStore } from '@/shared/lib/auth/two-factor-challenge.store'

/**
 * @description Reads the pending two-factor challenge and exposes its set/clear actions.
 * @returns {ReturnType<typeof useTwoFactorChallengeStore>} The current challenge and the
 * setChallenge/clearChallenge mutators.
 */
export function useTwoFactorChallenge() {
  return useTwoFactorChallengeStore((state) => state)
}
